<template>
  <aside class="bg-base-200 w-72">
    <div class="z-20 bg-base-200 bg-opacity-90 backdrop-blur sticky top-0 items-center gap-2 px-4 py-2 lg:flex shadow-sm">
      <div class="w-8 rounded">
        <img class="rounded" src="/img/icons/android-chrome-192x192.png">
      </div>
      <div class="flex-0 btn btn-ghost px-2">
        <div class="font-title normal-case text-primary inline-flex text-lg transition-all duration-200 md:text-3xl">
          <span>Гоё <span class="text-base-content">амьдрал</span></span>
        </div>
      </div>
    </div>
    <ul class="menu p-2 rounded-box">
      <template v-for="item in list">
        <template v-if="!item.roles || item.roles.includes(roleCode)">
          <li :key="item.name" v-if="item.divider"></li>
          <li :key="item.name" v-else-if="item.group" class="menu-title">
            <span>{{ item.title }}</span>
          </li>
          <li :key="item.name" v-else>
            <router-link :to="item.path" :class="{ 'active': item.name.includes(routeName) }"><hero-icon :name="item.icon"/><span>{{ item.title }}</span></router-link>
          </li>
        </template>
      </template>
    </ul>
  </aside>
</template>
<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  data () {
    return {
      list: [
        { title: 'Үндсэн цэс', group: true },
        { name: 'all', title: 'Бүгд', path: '/all', icon: 'database' },
        { name: 'current', title: 'Энэ удаа орох', path: '/current', icon: 'badge-check' },
        { name: 'postponed', title: 'Хойшилсон', path: '/postponed', icon: 'clock' },
        { name: 'dashboard home', title: 'Хянах салбар', path: '/dashboard', icon: 'chart-pie' },
        { name: 'payment', title: 'Гүйлгээ', path: '/payment', icon: 'currency-dollar' },
        { name: 'treatment', title: 'Эмчилгээний огноо', path: '/treatment', icon: 'briefcase' },
        { name: 'sms', title: 'Мессеж', path: '/sms', icon: 'chat-alt-2' },
        { divider: true, roles: ['1'] },
        { title: 'Тохиргоо', group: true, roles: ['1'] },
        { name: 'users', title: 'Хэрэглэгч', path: '/users', icon: 'user-circle', roles: ['1'] },
        { name: 'cancel', title: 'Цуцлах шалтгаан', path: '/lookups/cancel_types', icon: 'view-list', roles: ['1'] },
        { name: 'amount', title: 'Төлбөр', path: '/amount', icon: 'view-list', roles: ['1'] }
      ]
    }
  },
  computed: {
    ...mapGetters(['user']),
    roleCode () {
      return _.get(this.user, 'role.code')
    },
    routeName () {
      return this.$route.params.name || this.$route.name || 'none'
    }
  }
}
</script>
